import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import CreateCustomer from "./CreateCustomer";

const CreateWrapper = () => {
  const [createModal, setCreateModal] = useState(false);

  const handleShowModal = () => {
    setCreateModal(true);
  };

  const handleHideModal = () => {
    setCreateModal(false);
  };

  return (
    <>
      <button
        onClick={() => handleShowModal()}
        className="border rounded-md px-2 py-1 flex items-center"
      >
        <AiOutlinePlus />
        <span className="ml-2">New</span>
      </button>
      <CreateCustomer isVisible={createModal} hideModal={handleHideModal} />
    </>
  );
};

export default CreateWrapper;
